export default function ChatButton() {
  return (
    <a
      href="https://instagram.com/siimply.trade"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on Instagram"
      style={{
        position: "fixed",
        left: "16px",
        bottom: "16px",
        width: "56px",
        height: "56px",
        borderRadius: "9999px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "white",
        fontWeight: 700,
        boxShadow: "0 6px 18px rgba(0,0,0,.2)",
        zIndex: 9999,
        textDecoration: "none",
      }}
    >
      ?
    </a>
  );
}
